import React from "react";
import logo from "../../images/logo-baccredomatic.svg";
import styled from "styled-components";
import breakpoint from "styled-components-breakpoint";
import BotonHamburger from "./boton-hamburger";
import FaPlus from "react-icons/lib/fa/plus";
import Wrapper from "../../components/layout/Wrapper";
import TopMenu from "./TopMenu";
import MenuLinks from "./MenuLinks";

const Container = styled.div`
  border-bottom: solid 1px #e9e9e9;
`;

const Grid = styled(Wrapper)`
  padding: 1rem 1.5rem 15px;
  box-sizing: border-box;
  width: 100%;
  position: relative;
  z-index: 3;

  @supports (display: grid) {
    display: grid;
    grid-template-columns: 1fr 1.5fr;
    grid-column-gap: 3rem;
  }

  @supports not (display: grid) {
    display: flex;
  }

  ${breakpoint("tablet")`
    @supports (display: grid) {
      grid-template-columns: 1fr 3fr;
      grid-column-gap: 3rem;
    }
    padding: 2rem 3rem;
  `}

  ${breakpoint("desktop")`
    @supports (display: grid) {
      grid-template-columns: 200px 1fr;
      grid-column-gap: 3rem;
    }
    padding: 2rem 0 15px;
  `}
`;

const LogoContainer = styled.div`
  @supports not (display: grid) {
    flex: 2 0;

    img {
      max-width: 100%;
    }
  }
`;

const MenuContainer = styled.div`
  @supports not (display: grid) {
    flex: 8 0;
    position: relative;
  }
`;

const Menu = styled.ul`
  display: none;

  ${breakpoint("tablet")`
    list-style: none;
    padding: 0;
    margin: 0;
    height: 100%;

    @supports (display: grid) {
      display: grid;
      align-items: end;
      justify-items: end;
      justify-content: end;
      align-content: end;
      grid-template-columns: repeat(${props => props.count}, auto);
      grid-column-gap: 2rem;
    }

    @supports not (display: grid) {
      display: flex;
      text-align: right;
      height: 100%;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
    }
  `}
`;

const Item = styled.li`
  display: block;
  margin: 0;
  padding: 0;
  text-align: right;

  ${breakpoint("desktop")`
    @supports not (display: grid) {
      display: inline-block;
      text-align: right;
      margin-left: 20px;
      align-self: flex-end;
    }
  `}

  a {
    font-size: 13px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 2;
    letter-spacing: normal;
    color: #58595b;
    font-family: "Helvetica";
    text-decoration: none;
    transition: color 0.2s;

    &:hover {
      color: #f45354;
      text-decoration: underline;
    }
  }
`;

const ExpandibleMenu = styled.div`
  background: #fff;
  display: block;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  height: auto;
  max-height: ${props => (props.expanded ? `100vh` : `0`)};
  overflow: hidden;
  transition: max-height 0.2s ease;
  box-shadow: ${props =>
    props.expanded ? `0px 2px 3px rgba(0, 0, 0, .2)` : `none`};
  box-sizing: border-box;

  ${breakpoint("tablet")`
    display: none;
  `}
`;

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      extended: false
    };
    this.toggleMenuState = this.toggleMenuState.bind(this);
    this.collapseMenu = this.collapseMenu.bind(this);
  }

  toggleMenuState() {
    const expanded = !this.state.expanded;
    this.setState({ expanded });
  }

  collapseMenu() {
    this.setState({ expanded: false });
  }

  render() {
    const {
      countrySlug, title: country
    } = this.props;
    const menuLinks = MenuLinks.find(i => i.country === country).items;
    const { expanded } = this.state;

    return (
      <Container>
        <TopMenu countrySlug={countrySlug} countryName={country} />
        <Grid>
          <LogoContainer>
            <h1 style={{ margin: 0 }}>
              <a
                href={`https://www.baccredomatic.com/${countrySlug}/`}
                style={{
                  textDecoration: "none",
                  display: "block",
                  margin: 0
                }}
                onClick={e => this.collapseMenu()}
              >
                <img
                  src={logo}
                  alt="BAC Credomatic"
                  style={{ margin: 0, maxWidth: `100%` }}
                />
              </a>
            </h1>
          </LogoContainer>
          <MenuContainer>
            <Menu count={menuLinks.length}>
              {menuLinks.map(link => (
                <Item key={link.id}>
                  <a href={`https://www.baccredomatic.com/${link.slug}`}>
                    {link.titulo}
                  </a>
                </Item>
              ))}
            </Menu>
            <BotonHamburger toggleMenuState={e => this.toggleMenuState(e)} />
          </MenuContainer>
          <ExpandibleMenu expanded={expanded}>
            <div
              style={{
                borderTop: `2px solid #979797`,
                padding: `10px 0`
              }}
            >
              {menuLinks.map(link => (
                <a
                  href={`https://www.baccredomatic.com/${link.slug}`}
                  onClick={e => this.collapseMenu()}
                  key={link.id}
                  style={{
                    fontFamily: `"Trebuchet MS","Lucida Grande","Lucida Sans","Tahoma","sans-serif"`,
                    fontSize: `16px`,
                    lineHeight: `1.19`,
                    padding: `14px 25px 14px 50px`,
                    textDecoration: `none`,
                    background: `none`,
                    color: `#6D6E71`,
                    display: `block`,
                    position: `relative`,
                    fontWeight: `100`
                  }}
                >
                  <div
                    style={{
                      position: `absolute`,
                      left: 0,
                      top: 0,
                      bottom: 0,
                      background: `transparent`,
                      fontSize: `11px`,
                      display: `flex`,
                      flexDirection: `column`,
                      justifyContent: `center`,
                      padding: `0 0 0 20px`,
                      zIndex: 0,
                      fontWeight: `50`
                    }}
                  >
                    <FaPlus />
                  </div>
                  {link.titulo}
                </a>
              ))}
            </div>
          </ExpandibleMenu>
        </Grid>
      </Container>
    );
  }
}

export default Header;
